import { QueryObserverResult, useQuery } from '@tanstack/react-query';

import {
  API_QUERY_KEYS,
  getReasonsForLateResponse,
  GetReasonsForLateResponseResponse,
  QueryDefaults,
} from 'api';

export const useReasonsForLateResponse =
  (): QueryObserverResult<GetReasonsForLateResponseResponse> =>
    useQuery(
      [API_QUERY_KEYS.getReasonsForLateResponse],
      getReasonsForLateResponse,
      QueryDefaults
    );
